/** Admin布局 — 240px侧边栏 + 内容区 + 右下角蓝宝AI浮动助手
 *  移动端适配（P1）：md(900px) 以下侧栏收进临时 Drawer + TopBar 汉堡按钮；桌面端布局不变 */
import { useState, useCallback } from 'react';
import { Box, Drawer, useMediaQuery, useTheme } from '@mui/material';
import { Outlet } from 'react-router-dom';
import Sidebar from '@/components/admin/Sidebar';
import TopBar from '@/components/admin/TopBar';
import TodoCountProvider from '@/components/common/TodoCountProvider';
import LanBaoAssistant from '@/components/common/LanBaoAssistant';

export default function AdminLayout() {
  const theme = useTheme();
  // md(900px) 以下视为窄屏：侧栏不占位，改走 Drawer
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const [navOpen, setNavOpen] = useState(false);

  const openNav = useCallback(() => setNavOpen(true), []);
  const closeNav = useCallback(() => setNavOpen(false), []);

  return (
    <TodoCountProvider>
      <Box sx={{ display: 'flex', height: '100vh' }}>
        {/* 桌面：固定侧栏常驻；窄屏：不渲染（走下方 Drawer） */}
        {!isMobile && <Sidebar />}
        <Box sx={{ flex: 1, minWidth: 0, display: 'flex', flexDirection: 'column', overflow: 'hidden' }}>
          <TopBar onMenuClick={isMobile ? openNav : undefined} />
          <Box
            component="main"
            sx={{
              flex: 1,
              overflow: 'auto',
              p: { xs: 1.75, md: 3 },
              // 设计稿：页面顶部淡绿光晕 + 浅绿灰底（随内容滚动）
              backgroundColor: '#F4F8F6',
              backgroundImage:
                'radial-gradient(120% 420px at 50% -120px, rgba(52,211,153,0.16) 0%, rgba(167,243,208,0.06) 45%, rgba(255,255,255,0) 75%)',
              backgroundRepeat: 'no-repeat',
              backgroundAttachment: 'local',
            }}
          >
            <Outlet />
          </Box>
        </Box>
      </Box>

      {/* 窄屏：汉堡菜单拉出的临时导航抽屉（点菜单项/遮罩自动关闭） */}
      <Drawer
        variant="temporary"
        open={navOpen}
        onClose={closeNav}
        ModalProps={{ keepMounted: true }}
        sx={{ '& .MuiDrawer-paper': { width: 240, boxSizing: 'border-box' } }}
      >
        <Sidebar onNavigate={closeNav} />
      </Drawer>

      {/* 全站常驻：右下角蓝宝AI浮动助手（问答/翻译，独立于蓝宝AI问答页的会话） */}
      <LanBaoAssistant />
    </TodoCountProvider>
  );
}
